/**
 * Credit balance query hook — fetches balance for the current user's primary org.
 * Used by the nav header credit widget.
 *
 * @spec SPEC:FEATURE:BILLING-CREDITS
 */
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/context/AuthContext'
import { api } from '@/lib/api'
import type { CreditBalance } from '@/types'

export const creditKeys = {
  balance: () => ['credits', 'balance'] as const,
}

export function useCredits() {
  const { isAuthenticated } = useAuth()

  return useQuery({
    queryKey: creditKeys.balance(),
    queryFn: () => api.get<CreditBalance>('/credits/balance'),
    enabled: isAuthenticated,
    // Balance changes after each job — use a 30s stale time so the widget
    // stays reasonably fresh between jobs without hammering the API
    staleTime: 30_000,
    // Refetch on window focus so balance updates after returning from another tab
    refetchOnWindowFocus: true,
  })
}
